// 統一以台灣時區計算「今天」，避免海外或跨午夜使用者與後端 (Asia/Taipei) 差一天。
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const TAIPEI_TZ = 'Asia/Taipei';

// 目前的台灣時間 (dayjs 物件)
export const nowTpe = (): dayjs.Dayjs => dayjs().tz(TAIPEI_TZ);

// 台灣時區的今天，格式 YYYY-MM-DD
export const todayTpe = (): string => nowTpe().format('YYYY-MM-DD');

// 台灣時區今天往前 n 天，格式 YYYY-MM-DD
export const daysAgoTpe = (days: number): string =>
  nowTpe().subtract(days, 'day').format('YYYY-MM-DD');
